import React, { useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import {
    Button,
    CardActions,
    Divider,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
} from "@mui/material";
import StairsIcon from '@mui/icons-material/Stairs';
import { useNavigate } from "react-router-dom";

const RankingCard = ({ ranking, users }) => {
    const navigate = useNavigate();

    useEffect(() => {
    }, [ranking, users]);

    const handleNavigateDetails = () => {
        navigate("/ranking");
    };

    const getMedalEmoji = (index) => {
        switch (index) {
            case 0:
                return '🥇';
            case 1:
                return '🥈';
            case 2:
                return '🥉';
            default:
                return index + 1;
        }
    };

    return (
        <Card
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                minWidth: 200,
                minHeight: 350,
                maxHeight: 350,
            }}
        >
            <CardContent>
                <Stack spacing={1} direction="row" sx={{ alignItems: "center", mb: 1 }}>
                    <StairsIcon />
                    <Typography variant="h6" color="primary" sx={{ mr: 1 }} gutterBottom>
                        Ranking
                    </Typography>
                </Stack>

                <Divider />
                <TableContainer>
                    <Table>
                        {ranking && users && <TableBody>
                            {ranking.ranks.sort((a, b) => b.rank - a.rank).slice(0, 4).map((rank, index) => (<TableRow key={rank.participantId}>
                                <TableCell>{getMedalEmoji(index)}</TableCell>
                                <TableCell><Typography sx={{ fontSize: 16, mr: 1 }}>{users.find(user => user.id === rank.participantId)?.nickname}</Typography></TableCell>
                                <TableCell>{rank.rank}</TableCell>
                            </TableRow>))}
                        </TableBody>}
                    </Table>
                </TableContainer>
            </CardContent>
            <CardActions>
                <Button size="small" onClick={handleNavigateDetails}>
                    Details
                </Button>
            </CardActions>
        </Card>
    );
};

export default RankingCard;
